export interface CatoAutoTriageConfig {
  sources: string[];
  severities: string[];
  enabled: boolean;
}

export const CATO_DEFAULT_CONFIG: CatoAutoTriageConfig = {
  sources: ['nuclei'],
  severities: ['TC'],
  enabled: true,
};

export const CATO_SETTING_KEY = 'cato_auto_triage';
